import { ApplicationContractResponse } from '@acme/api';
import { Separator, renderFieldIfText } from '@acme/foundation';

export const ContractInfo = ({
  contract,
}: {
  contract: ApplicationContractResponse | null;
}) => {
  if (!contract) return null;

  return (
    <>
      <Separator className="-mx-6" />
      <div className="flex flex-col gap-6">
        <div className="text-xl font-semibold text-gray-900">
          Данные по договору
        </div>

        <div className="grid grid-cols-3 gap-6 items-center">
          {renderFieldIfText(
            'Уникальный номер контракта',
            contract.uniqueContractNumber
          )}
          {renderFieldIfText(
            'Номер внешнеторгового договора',
            contract.foreignTradeAgreementNumber
          )}
        </div>
      </div>
    </>
  );
};
